import React, { createContext } from "react";

export const MovieContext = createContext();

const MovieProvider = ({ children }) => {
  const PopularMovies = [
    {
      adult: false,
      backdrop_path: "/jr8tSoJGj33XLgFBy6lmZhpGQNu.jpg",
      genre_ids: [16, 12, 35, 10751],
      id: 315162,
      original_language: "en",
      original_title: "Puss in Boots: The Last Wish",
      overview:
        "Puss in Boots discovers that his passion for adventure has taken its toll: He has burned through eight of his nine lives, leaving him with only one life left. Puss sets out on an epic journey to find the mythical Last Wish and restore his nine lives.",
      popularity: 3030.726,
      poster_path: "/kuf6dutpsT0vSVehic3EZIqkOBt.jpg",
      release_date: "2022-12-07",
      title: "Puss in Boots: The Last Wish",
      video: false,
      vote_average: 8.4,
      vote_count: 4695,
    },
    {
      adult: false,
      backdrop_path: "/2Eewgp7o5AU1xCataDmiIL2nYxd.jpg",
      genre_ids: [18, 36],
      id: 943822,
      original_language: "en",
      original_title: "Prizefighter: The Life of Jem Belcher",
      overview:
        "At the turn of the 19th century, Pugilism was the sport of kings and a gifted young boxer fought his way to becoming champion of England.",
      popularity: 3136.216,
      poster_path: "/x3PIk93PTbxT88ohfeb26L1VpZw.jpg",
      release_date: "2022-06-30",
      title: "Prizefighter: The Life of Jem Belcher",
      video: false,
      vote_average: 7.1,
      vote_count: 56,
    },
    {
      adult: false,
      backdrop_path: "/nDg8feBTHh52YCAuXpFWynznqAh.jpg",
      genre_ids: [53, 28],
      id: 850871,
      original_language: "es",
      original_title: "Sayen",
      overview:
        "Sayen is hunting down the men who murdered her grandmother. Using her training and knowledge of nature, she is able to turn the tables on them, learning of a conspiracy from a corporation that threatens her people's ancestral lands.",
      popularity: 2133.689,
      poster_path: "/aCy61aU7BMG7SfhkaAaasS0KzUO.jpg",
      release_date: "2023-03-03",
      title: "Sayen",
      video: false,
      vote_average: 6.6,
      vote_count: 40,
    },
    {
      adult: false,
      backdrop_path: "/xDMIl84Qo5Tsu62c9DGWhmPI67A.jpg",
      genre_ids: [28, 12, 878],
      id: 505642,
      original_language: "en",
      original_title: "Black Panther: Wakanda Forever",
      overview:
        "Queen Ramonda, Shuri, M’Baku, Okoye and the Dora Milaje fight to protect their nation from intervening world powers in the wake of King T’Challa’s death.  As the Wakandans strive to embrace their next chapter, the heroes must band together with the help of War Dog Nakia and Everett Ross and forge a new path for the kingdom of Wakanda.",
      popularity: 2299.001,
      poster_path: "/sv1xJUazXeYqALzczSZ3O6nkH75.jpg",
      release_date: "2022-11-09",
      title: "Black Panther: Wakanda Forever",
      video: false,
      vote_average: 7.3,
      vote_count: 4179,
    },
    {
      adult: false,
      backdrop_path: "/wybmSmviUXxlBmX44gtpow5Y9TB.jpg",
      genre_ids: [28, 35, 14],
      id: 594767,
      original_language: "en",
      original_title: "Shazam! Fury of the Gods",
      overview:
        'Billy Batson and his foster siblings, who transform into superheroes by saying "Shazam!", are forced to get back into action and fight the Daughters of Atlas, who they must stop from using a weapon that could destroy the world.',
      popularity: 1807.915,
      poster_path: "/A3ZbZsmsvNGdprRi2lKgGEeVLEH.jpg",
      release_date: "2023-03-15",
      title: "Shazam! Fury of the Gods",
      video: false,
      vote_average: 7.3,
      vote_count: 118,
    },
    {
      adult: false,
      backdrop_path: "/22z44LPkMyf5nyyXvv8qQLsbom.jpg",
      genre_ids: [27, 9648, 53],
      id: 631842,
      original_language: "en",
      original_title: "Knock at the Cabin",
      overview:
        "While vacationing at a remote cabin, a young girl and her two fathers are taken hostage by four armed strangers who demand that the family make an unthinkable choice to avert the apocalypse. With limited access to the outside world, the family must decide what they believe before all is lost.",
      popularity: 2099.087,
      poster_path: "/dm06L9pxDOL9jNSK4Cb6y139rrG.jpg",
      release_date: "2023-02-01",
      title: "Knock at the Cabin",
      video: false,
      vote_average: 6.4,
      vote_count: 1052,
    },
    {
      adult: false,
      backdrop_path: "/AsEgGeccI32SwMBkxpwhOkhbzmF.jpg",
      genre_ids: [28, 878, 53, 27],
      id: 1011679,
      original_language: "en",
      original_title: "Shark Side of the Moon",
      overview:
        "Decades ago, the USSR developed unkillable sharks and launched them to the moon. Today, a team of American astronauts will endure the fight of their lives.",
      popularity: 1794.023,
      poster_path: "/v5CfpzxoJDkZxjZAizClFdlEF0U.jpg",
      release_date: "2022-08-12",
      title: "Shark Side of the Moon",
      video: false,
      vote_average: 5.3,
      vote_count: 92,
    },
    {
      adult: false,
      backdrop_path: "/2E6pIbJien7B9yWpaz8Yd2njzUI.jpg",
      genre_ids: [18, 27],
      id: 1026563,
      original_language: "es",
      original_title: "13 exorcismos",
      overview:
        "After participating in a séance, young Laura begins to behave strangely. Alarmed, her parents ask Father Olmedo, one of the few exorcists authorized by the Vatican to intervene in cases of demonic possession, for help.",
      popularity: 1903.25,
      poster_path: "/2yzpiUeOQHnbiOayAAwG0FcXRmc.jpg",
      release_date: "2022-11-04",
      title: "13 Exorcisms",
      video: false,
      vote_average: 6.3,
      vote_count: 15,
    },
    {
      adult: false,
      backdrop_path: "/r7Dfg9aRZ78gJsmDlCirIIlNH3d.jpg",
      genre_ids: [18],
      id: 785084,
      original_language: "en",
      original_title: "The Whale",
      overview:
        "A reclusive English teacher suffering from severe obesity attempts to reconnect with his estranged teenage daughter for one last chance at redemption.",
      popularity: 1535.66,
      poster_path: "/jQ0gylJMxWSL490sy0RrPj1Lj7e.jpg",
      release_date: "2022-12-09",
      title: "The Whale",
      video: false,
      vote_average: 8.1,
      vote_count: 1425,
    },
    {
      adult: false,
      backdrop_path: "/pxJbfnMIQQxCrdeLD0zQnWr6ouL.jpg",
      genre_ids: [28, 35, 53],
      id: 1077280,
      original_language: "en",
      original_title: "Die Hart",
      overview:
        "Kevin Hart - playing a version of himself - is on a death-defying quest to become an action star. And with a little help from John Travolta, Nathalie Emmanuel, and Josh Hartnett - he just might pull it off.",
      popularity: 1552.668,
      poster_path: "/1EnBjTJ5utgT1OXYBZ8YwByRCzP.jpg",
      release_date: "2023-02-22",
      title: "Die Hart",
      video: false,
      vote_average: 6.2,
      vote_count: 196,
    },
    {
      adult: false,
      backdrop_path: "/9Rq14Eyrf7Tu1xk0Pl7VcNbNh1n.jpg",
      genre_ids: [28, 12, 53],
      id: 646389,
      original_language: "en",
      original_title: "Plane",
      overview:
        "After a heroic job of successfully landing his storm-damaged aircraft in a war zone, a fearless pilot finds himself between the agendas of multiple militias planning to take the plane and its passengers hostage.",
      popularity: 1609.592,
      poster_path: "/qi9r5xBgcc9KTxlOLjssEbDgO0J.jpg",
      release_date: "2023-01-12",
      title: "Plane",
      video: false,
      vote_average: 6.9,
      vote_count: 915,
    },
    {
      adult: false,
      backdrop_path: "/5i6SjyDbDWqyun8klUuCxrlFbyw.jpg",
      genre_ids: [18],
      id: 677179,
      original_language: "en",
      original_title: "Creed III",
      overview:
        "After dominating the boxing world, Adonis Creed has been thriving in both his career and family life. When a childhood friend and former boxing prodigy, Damien Anderson, resurfaces after serving a long sentence in prison, he is eager to prove that he deserves his shot in the ring. The face-off between former friends is more than just a fight. To settle the score, Adonis must put his future on the line to battle Damien — a fighter who has nothing to lose.",
      popularity: 1256.463,
      poster_path: "/vJU3rXSP9hwUuLeq8IpfsJShLOk.jpg",
      release_date: "2023-03-01",
      title: "Creed III",
      video: false,
      vote_average: 7.1,
      vote_count: 370,
    },
    {
      adult: false,
      backdrop_path: "/ovM06PdF3M8wvKb06i4sjW3xoww.jpg",
      genre_ids: [878, 12, 28],
      id: 76600,
      original_language: "en",
      original_title: "Avatar: The Way of Water",
      overview:
        "Set more than a decade after the events of the first film, learn the story of the Sully family (Jake, Neytiri, and their kids), the trouble that follows them, the lengths they go to keep each other safe, the battles they fight to stay alive, and the tragedies they endure.",
      popularity: 1386.933,
      poster_path: "/t6HIqrRAclMCA60NsSmeqe9RmNV.jpg",
      release_date: "2022-12-14",
      title: "Avatar: The Way of Water",
      video: false,
      vote_average: 7.7,
      vote_count: 5789,
    },
    {
      adult: false,
      backdrop_path: "/dlrWhn0G3AtxYUx2D9P2bmzcsvF.jpg",
      genre_ids: [878, 27, 35],
      id: 536554,
      original_language: "en",
      original_title: "M3GAN",
      overview:
        "A brilliant toy company roboticist uses artificial intelligence to develop M3GAN, a life-like doll programmed to emotionally bond with her newly orphaned niece. But when the doll's programming works too well, she becomes overprotective of her new friend with terrifying results.",
      popularity: 1285.001,
      poster_path: "/d9nBoowhjiiYc4FBNtQkPY7c11H.jpg",
      release_date: "2022-12-28",
      title: "M3GAN",
      video: false,
      vote_average: 7.4,
      vote_count: 2113,
    },
    {
      adult: false,
      backdrop_path: "/op4UFvEP6TlG3JgAOtZBVzAXBjK.jpg",
      genre_ids: [53, 35],
      id: 804150,
      original_language: "en",
      original_title: "Cocaine Bear",
      overview:
        "Inspired by a true story, an oddball group of cops, criminals, tourists and teens converge in a Georgia forest where a 500-pound black bear goes on a murderous rampage after unintentionally ingesting cocaine.",
      popularity: 1389.748,
      poster_path: "/gOnmaxHo0412UVr1QM5Nekv1xPi.jpg",
      release_date: "2023-02-22",
      title: "Cocaine Bear",
      video: false,
      vote_average: 6.6,
      vote_count: 295,
    },
    {
      adult: false,
      backdrop_path: "/A2avUoNFstnBhAnHiogXQs4c9Bt.jpg",
      genre_ids: [18, 27, 9648],
      id: 772515,
      original_language: "es",
      original_title: "Huesera",
      overview:
        "Valeria's joy at becoming a first-time mother is quickly taken away when she's cursed by a sinister entity. As danger closes in, she's forced deeper into a chilling world of dark magic that threatens to consume her.",
      popularity: 950.666,
      poster_path: "/zgpj76z9byUgcWnxLDmtZ3XqfvN.jpg",
      release_date: "2023-02-10",
      title: "Huesera: The Bone Woman",
      video: false,
      vote_average: 5.8,
      vote_count: 151,
    },
    {
      adult: false,
      backdrop_path: "/bvAMLx00BOr6vkSQWZscwGrPdGI.jpg",
      genre_ids: [53, 28, 18, 80],
      id: 1058949,
      original_language: "en",
      original_title: "Little Dixie",
      overview:
        "Erstwhile Special Forces operative Doc Alexander is asked to broker a truce with the Mexican drug cartel in secrecy. When Oklahoma Governor Richard Jeffs celebrates the execution of a high-ranking cartel member on TV, his Chief of Staff and Doc inform him about the peace he just ended. But it’s too late, as Cuco, the cartel’s hatchet man, has set his vengeful sights on Doc’s daughter Dixie.",
      popularity: 1033.858,
      poster_path: "/cmWTZj9zzT9KFt3XyL0gssL7Ig8.jpg",
      release_date: "2023-02-03",
      title: "Little Dixie",
      video: false,
      vote_average: 6,
      vote_count: 83,
    },
    {
      adult: false,
      backdrop_path: "/32GH8Mi4GmTPIQyd6IW1FFrHWrj.jpg",
      genre_ids: [28],
      id: 965839,
      original_language: "en",
      original_title: "Lord of the Streets",
      overview:
        "When Jason Dyson refuses to make his prized fighter throw an MMA match, a notorious gangster collects his debt by killing the fighter and kidnapping Jason's daughter. Now he must train a prisoner to endure five consecutive underground fights to save her.",
      popularity: 1040.924,
      poster_path: "/mbigXpUgVgLOacgxlyFfsLRFqxQ.jpg",
      release_date: "2022-04-22",
      title: "Lord of the Streets",
      video: false,
      vote_average: 5.3,
      vote_count: 46,
    },
    {
      adult: false,
      backdrop_path: "/gslT8t964rYXyqRcqrxFh77ikyb.jpg",
      genre_ids: [12, 878, 35],
      id: 640146,
      original_language: "en",
      original_title: "Ant-Man and the Wasp: Quantumania",
      overview:
        "Super-Hero partners Scott Lang and Hope van Dyne, along with with Hope's parents Janet van Dyne and Hank Pym, and Scott's daughter Cassie Lang, find themselves exploring the Quantum Realm, interacting with strange new creatures and embarking on an adventure that will push them beyond the limits of what they thought possible.",
      popularity: 1039.865,
      poster_path: "/ngl2FKBlU4fhbdsrtdom9LVLBXw.jpg",
      release_date: "2023-02-15",
      title: "Ant-Man and the Wasp: Quantumania",
      video: false,
      vote_average: 6.4,
      vote_count: 1045,
    },
    {
      adult: false,
      backdrop_path: "/ql4PnvKYKaMtdx9Ck4fHY2wJphT.jpg",
      genre_ids: [35, 18, 10749],
      id: 32516,
      original_language: "cn",
      original_title: "金瓶梅2 愛的奴隸",
      overview:
        "Rich and powerful Simon Qing has been schooled in the ways of sex by his virile father, but is still a virgin. That is, until he meets his first love Violetta who has fun with him all over his father’s estate. Their love does not last, so Simon embarks on a journey. Along the way he meets the comely nun Moon whom Simon deflowers and then marries. He then becomes enamored of Golden Lotus but she is married to dwarf Wu Da-Lang.",
      popularity: 808.977,
      poster_path: "/A1yymig7S0FTWv9cTtOwdI1cH5V.jpg",
      release_date: "2009-03-04",
      title: "The Forbidden Legend: Sex & Chopsticks 2",
      video: false,
      vote_average: 6.1,
      vote_count: 57,
    },
  ];

  const TopMovies = [
    {
      adult: false,
      backdrop_path: "/tmU7GeKVybMWFButWEGl2M4GeiP.jpg",
      genre_ids: [18, 80],
      id: 238,
      original_language: "en",
      original_title: "The Godfather",
      overview:
        "Spanning the years 1945 to 1955, a chronicle of the fictional Italian-American Corleone crime family. When organized crime family patriarch, Vito Corleone barely survives an attempt on his life, his youngest son, Michael steps in to take care of the would-be killers, launching a campaign of bloody revenge.",
      popularity: 119.411,
      poster_path: "/3bhkrj58Vtu7enYsRolD1fZdja1.jpg",
      release_date: "1972-03-14",
      title: "The Godfather",
      video: false,
      vote_average: 8.7,
      vote_count: 17619,
    },
    {
      adult: false,
      backdrop_path: "/wPU78OPN4BYEgWYdXyg0phMee64.jpg",
      genre_ids: [18, 80],
      id: 278,
      original_language: "en",
      original_title: "The Shawshank Redemption",
      overview:
        "Framed in the 1940s for the double murder of his wife and her lover, upstanding banker Andy Dufresne begins a new life at the Shawshank prison, where he puts his accounting skills to work for an amoral warden. During his long stretch in prison, Dufresne comes to be admired by the other inmates -- including an older prisoner named Red -- for his integrity and unquenchable sense of hope.",
      popularity: 108.339,
      poster_path: "/hBcY0fE9pfXzvVaY4GKarweriG2.jpg",
      release_date: "1994-09-23",
      title: "The Shawshank Redemption",
      video: false,
      vote_average: 8.7,
      vote_count: 23463,
    },
    {
      adult: false,
      backdrop_path: "/ejniJnlOdtSgtbh8D7u2RxT6Uli.jpg",
      genre_ids: [35, 14],
      id: 772071,
      original_language: "es",
      original_title: "Cuando Sea Joven",
      overview:
        '70-year-old Malena gets a second chance at life when she magically turns into her 22-year-old self. Now, posing as "Maria" to hide her true identity, she becomes the lead singer of her grandson\'s band and tries to recover her dream of singing, which she had to give up at some point.',
      popularity: 59.051,
      poster_path: "/6gIJuFHh5Lj4dNaPG3TzIMl7L68.jpg",
      release_date: "2022-09-14",
      title: "Cuando Sea Joven",
      video: false,
      vote_average: 8.7,
      vote_count: 211,
    },
    {
      adult: false,
      backdrop_path: "/kGzFbGhp99zva6oZODW5atUtnqi.jpg",
      genre_ids: [18, 80],
      id: 240,
      original_language: "en",
      original_title: "The Godfather Part II",
      overview:
        "In the continuing saga of the Corleone crime family, a young Vito Corleone grows up in Sicily and in 1910s New York. In the 1950s, Michael Corleone attempts to expand the family business into Las Vegas, Hollywood and Cuba.",
      popularity: 74.914,
      poster_path: "/hek3koDUyRQk7FIhPXsa6mT2Zc3.jpg",
      release_date: "1974-12-20",
      title: "The Godfather Part II",
      video: false,
      vote_average: 8.6,
      vote_count: 10674,
    },
    {
      adult: false,
      backdrop_path: "/zb6fM1CX41D9rF9hdgclu0peUmy.jpg",
      genre_ids: [18, 36, 10752],
      id: 424,
      original_language: "en",
      original_title: "Schindler's List",
      overview:
        "The true story of how businessman Oskar Schindler saved over a thousand Jewish lives from the Nazis while they worked as slaves in his factory during World War II.",
      popularity: 63.594,
      poster_path: "/sF1U4EUQS8YHUYjNl3pMGNIQyr0.jpg",
      release_date: "1993-12-15",
      title: "Schindler's List",
      video: false,
      vote_average: 8.6,
      vote_count: 13876,
    },
    {
      adult: false,
      backdrop_path: "/vI3aUGTuRRdM7J78KIdW98LdxE5.jpg",
      genre_ids: [35, 18, 10749],
      id: 19404,
      original_language: "hi",
      original_title: "दिलवाले दुल्हनिया ले जायेंगे",
      overview:
        "Raj is a rich, carefree, happy-go-lucky second generation NRI. Simran is the daughter of Chaudhary Baldev Singh, who in spite of being an NRI is very strict about adherence to Indian values. Simran has left for India to be married to her childhood fiancé. Raj leaves for India with a mission at his hands, to claim his lady love under the noses of her whole family. Thus begins a saga.",
      popularity: 25.354,
      poster_path: "/2CAL2433ZeIihfX1Hb2139CX0pW.jpg",
      release_date: "1995-10-19",
      title: "Dilwale Dulhania Le Jayenge",
      video: false,
      vote_average: 8.6,
      vote_count: 4080,
    },
    {
      adult: false,
      backdrop_path: "/Ab8mkHmkYADjU7wQiOkia9BzGvS.jpg",
      genre_ids: [16, 10751, 14],
      id: 129,
      original_language: "ja",
      original_title: "千と千尋の神隠し",
      overview:
        "A young girl, Chihiro, becomes trapped in a strange new world of spirits. When her parents undergo a mysterious transformation, she must call upon the courage she never knew she had to free her family.",
      popularity: 93.602,
      poster_path: "/39wmItIWsg5sZMyRUHLkWBcuVCM.jpg",
      release_date: "2001-07-20",
      title: "Spirited Away",
      video: false,
      vote_average: 8.5,
      vote_count: 14075,
    },
    {
      adult: false,
      backdrop_path: "/tj6iPnz18hGfr0LKqWmG6Cp3niO.jpg",
      genre_ids: [18],
      id: 389,
      original_language: "en",
      original_title: "12 Angry Men",
      overview:
        "The defense and the prosecution have rested and the jury is filing into the jury room to decide if a young Spanish-American is guilty or innocent of murdering his father. What begins as an open and shut case soon becomes a mini-drama of each of the jurors' prejudices and preconceptions about the trial, the accused, and each other.",
      popularity: 46.235,
      poster_path: "/ppd84D2i9W8jXmsyInGyihiSyqz.jpg",
      release_date: "1957-04-10",
      title: "12 Angry Men",
      video: false,
      vote_average: 8.5,
      vote_count: 7124,
    },
    {
      adult: false,
      backdrop_path: "/dIWwZW7dJJtqC6CgWzYkNVKIUm8.jpg",
      genre_ids: [10749, 16, 18],
      id: 372058,
      original_language: "ja",
      original_title: "君の名は。",
      overview:
        "High schoolers Mitsuha and Taki are complete strangers living separate lives. But one night, they suddenly switch places. Mitsuha wakes up in Taki’s body, and he in hers. This bizarre occurrence continues to happen randomly, and the two must adjust their lives around each other.",
      popularity: 130.631,
      poster_path: "/q719jXXEzOoYaps6babgKnONONX.jpg",
      release_date: "2016-08-26",
      title: "Your Name.",
      video: false,
      vote_average: 8.5,
      vote_count: 9608,
    },
    {
      adult: false,
      backdrop_path: "/wxaBkuqVIgImjRHEMJoxL9Lq6i8.jpg",
      genre_ids: [16, 10751, 12, 14],
      id: 995133,
      original_language: "en",
      original_title: "The Boy, the Mole, the Fox and the Horse",
      overview:
        "The unlikely friendship of a boy, a mole, a fox and a horse traveling together in the boy’s search for home.",
      popularity: 48.006,
      poster_path: "/oQRgyQCzcyZvE6w5heM9ktVY0LT.jpg",
      release_date: "2022-12-25",
      title: "The Boy, the Mole, the Fox and the Horse",
      video: false,
      vote_average: 8.5,
      vote_count: 274,
    },
    {
      adult: false,
      backdrop_path: "/hiKmpZMGZsrkA3cdce8a7Dpos1j.jpg",
      genre_ids: [35, 53, 18],
      id: 496243,
      original_language: "ko",
      original_title: "기생충",
      overview:
        "All unemployed, Ki-taek's family takes peculiar interest in the wealthy and glamorous Parks for their livelihood until they get entangled in an unexpected incident.",
      popularity: 88.125,
      poster_path: "/7IiTTgloJzvGI1TAYymCfbfl3vT.jpg",
      release_date: "2019-05-30",
      title: "Parasite",
      video: false,
      vote_average: 8.5,
      vote_count: 15417,
    },
    {
      adult: false,
      backdrop_path: "/pbEkjhdfP7yuDcMB78YEZwgD4IN.jpg",
      genre_ids: [18, 28, 80, 53],
      id: 155,
      original_language: "en",
      original_title: "The Dark Knight",
      overview:
        "Batman raises the stakes in his war on crime. With the help of Lt. Jim Gordon and District Attorney Harvey Dent, Batman sets out to dismantle the remaining criminal organizations that plague the streets. The partnership proves to be effective, but they soon find themselves prey to a reign of chaos unleashed by a rising criminal mastermind known to the terrified citizens of Gotham as the Joker.",
      popularity: 92.42,
      poster_path: "/qJ2tW6WMUDux911r6m7haRef0WH.jpg",
      release_date: "2008-07-14",
      title: "The Dark Knight",
      video: false,
      vote_average: 8.5,
      vote_count: 29369,
    },
    {
      adult: false,
      backdrop_path: "/vxJ08SvwomfKbpboCWynC3uqUg4.jpg",
      genre_ids: [14, 18, 80],
      id: 497,
      original_language: "en",
      original_title: "The Green Mile",
      overview:
        "A supernatural tale set on death row in a Southern prison, where gentle giant John Coffey possesses the mysterious power to heal people's ailments. When the cell block's head guard, Paul Edgecomb, recognizes Coffey's miraculous gift, he tries desperately to help stave off the condemned man's execution.",
      popularity: 96.571,
      poster_path: "/velWPhVMQeQKcxggNEU8YmIo52R.jpg",
      release_date: "1999-12-10",
      title: "The Green Mile",
      video: false,
      vote_average: 8.5,
      vote_count: 15177,
    },
    {
      adult: false,
      backdrop_path: "/suaEOtk1N1sgg2MTM7oZd2cfVp3.jpg",
      genre_ids: [53, 80],
      id: 680,
      original_language: "en",
      original_title: "Pulp Fiction",
      overview:
        "A burger-loving hit man, his philosophical partner, a drug-addled gangster's moll and a washed-up boxer converge in this sprawling, comedic crime caper. Their adventures unfurl in three stories that ingeniously trip back and forth in time.",
      popularity: 70.05,
      poster_path: "/d5iIlFn5s0ImszYzBPb8JPIfbXD.jpg",
      release_date: "1994-09-10",
      title: "Pulp Fiction",
      video: false,
      vote_average: 8.5,
      vote_count: 24832,
    },
    {
      adult: false,
      backdrop_path: "/eoCSp75lxatmIa6aGqfnzwtbttd.jpg",
      genre_ids: [37],
      id: 429,
      original_language: "it",
      original_title: "Il buono, il brutto, il cattivo",
      overview:
        "While the Civil War rages on between the Union and the Confederacy, three men – a quiet loner, a ruthless hitman, and a Mexican bandit – comb the American Southwest in search of a strongbox containing $200,000 in stolen gold.",
      popularity: 70.527,
      poster_path: "/bX2xnavhMYjWDoZp1VM6VnU1xwe.jpg",
      release_date: "1966-12-23",
      title: "The Good, the Bad and the Ugly",
      video: false,
      vote_average: 8.5,
      vote_count: 7278,
    },
    {
      adult: false,
      backdrop_path: "/3h1JZGDhZ8nzxdgvkxha0qBqi05.jpg",
      genre_ids: [35, 18, 10749],
      id: 13,
      original_language: "en",
      original_title: "Forrest Gump",
      overview:
        "A man with a low IQ has accomplished great things in his life and been present during significant historic events—in each case, far exceeding what anyone imagined he could do. But despite all he has achieved, his one true love eludes him.",
      popularity: 73.861,
      poster_path: "/arw2vcBveWOVZr6pxd9XTd1TdQa.jpg",
      release_date: "1994-06-23",
      title: "Forrest Gump",
      video: false,
      vote_average: 8.5,
      vote_count: 24339,
    },
    {
      adult: false,
      backdrop_path: "/lXhgCODAbBXL5buk9yEmTpOoOgR.jpg",
      genre_ids: [12, 14, 28],
      id: 122,
      original_language: "en",
      original_title: "The Lord of the Rings: The Return of the King",
      overview:
        "Aragorn is revealed as the heir to the ancient kings as he, Gandalf and the other members of the broken fellowship struggle to save Gondor from Sauron's forces. Meanwhile, Frodo and Sam take the ring closer to the heart of Mordor, the dark lord's realm.",
      popularity: 103.191,
      poster_path: "/rCzpDGLbOoPwLjy3OAm5NUPOTrC.jpg",
      release_date: "2003-12-01",
      title: "The Lord of the Rings: The Return of the King",
      video: false,
      vote_average: 8.5,
      vote_count: 21305,
    },
    {
      adult: false,
      backdrop_path: "/3RMLbSEXOn1CzLoNT7xFeLfdxhq.jpg",
      genre_ids: [10749, 16],
      id: 372754,
      original_language: "ja",
      original_title: "同級生",
      overview:
        "Rihito Sajo, an honor student with a perfect score on the entrance exam and Hikaru Kusakabe, in a band and popular among girls, would have never crossed paths. Until one day they started talking at the practice for their school’s upcoming chorus festival. After school, the two meet regularly, as Hikaru helps Rihito to improve his singing skills. While they listen to each other’s voice and harmonize, their hearts start to beat together.",
      popularity: 12.945,
      poster_path: "/cIfRCA5wEvj9tApca4UDUagQEiM.jpg",
      release_date: "2016-02-20",
      title: "Dou kyu sei – Classmates",
      video: false,
      vote_average: 8.5,
      vote_count: 293,
    },
    {
      adult: false,
      backdrop_path: "/uBZQOYZLIU9dBmd62fdzBAoropu.jpg",
      genre_ids: [28, 12, 16, 18],
      id: 704264,
      original_language: "en",
      original_title: "Primal: Tales of Savagery",
      overview:
        "Genndy Tartakovsky's Primal: Tales of Savagery features a caveman and a dinosaur on the brink of extinction. Bonded by tragedy, this unlikely friendship becomes the only hope of survival.",
      popularity: 38.453,
      poster_path: "/9NBBkdxH0TjQEBSN2AzeE1sgsF9.jpg",
      release_date: "2019-11-21",
      title: "Primal: Tales of Savagery",
      video: false,
      vote_average: 8.5,
      vote_count: 261,
    },
    {
      adult: false,
      backdrop_path: "/w2uGvCpMtvRqZg6waC1hvLyZoJa.jpg",
      genre_ids: [10749],
      id: 696374,
      original_language: "en",
      original_title: "Gabriel's Inferno",
      overview:
        "An intriguing and sinful exploration of seduction, forbidden love, and redemption, Gabriel's Inferno is a captivating and wildly passionate tale of one man's escape from his own personal hell as he tries to earn the impossible--forgiveness and love.",
      popularity: 19.979,
      poster_path: "/oyG9TL7FcRP4EZ9Vid6uKzwdndz.jpg",
      release_date: "2020-05-29",
      title: "Gabriel's Inferno",
      video: false,
      vote_average: 8.5,
      vote_count: 2327,
    },
  ];

  return (
    <MovieContext.Provider value={{ PopularMovies, TopMovies }}>
      {children}
    </MovieContext.Provider>
  );
};

export default MovieProvider;
